import type { LabTest, RadiologyTest, MedicineTemplate } from '../types';

export const labTests: LabTest[] = [
  { code: 'CBC', name: 'Complete Blood Count', category: 'Hematology' },
  { code: 'LFT', name: 'Liver Function Test', category: 'Biochemistry' },
  { code: 'RFT', name: 'Renal Function Test', category: 'Biochemistry' },
  { code: 'FBS', name: 'Fasting Blood Sugar', category: 'Biochemistry' },
  { code: 'HbA1c', name: 'Glycated Hemoglobin', category: 'Biochemistry' },
  { code: 'TSH', name: 'Thyroid Stimulating Hormone', category: 'Endocrinology' },
  { code: 'ESR', name: 'Erythrocyte Sedimentation Rate', category: 'Hematology' },
  { code: 'CRP', name: 'C-Reactive Protein', category: 'Immunology' },
  { code: 'URINE', name: 'Urine Routine & Microscopy', category: 'Clinical Pathology' },
  { code: 'LIPID', name: 'Lipid Profile', category: 'Biochemistry' },
];

export const radiologyTests: RadiologyTest[] = [
  { code: 'CXR', name: 'Chest X-Ray', category: 'X-Ray' },
  { code: 'AXR', name: 'Abdominal X-Ray', category: 'X-Ray' },
  { code: 'CT-HEAD', name: 'CT Scan Head', category: 'CT' },
  { code: 'CT-CHEST', name: 'CT Scan Chest', category: 'CT' },
  { code: 'CT-ABDOMEN', name: 'CT Scan Abdomen', category: 'CT' },
  { code: 'MRI-BRAIN', name: 'MRI Brain', category: 'MRI' },
  { code: 'MRI-SPINE', name: 'MRI Spine', category: 'MRI' },
  { code: 'USG-ABDOMEN', name: 'Ultrasound Abdomen', category: 'Ultrasound' },
  { code: 'USG-PELVIS', name: 'Ultrasound Pelvis', category: 'Ultrasound' },
  { code: 'ECHO', name: 'Echocardiography', category: 'Ultrasound' },
];

export const medicineTemplates: MedicineTemplate[] = [
  {
    name: 'Paracetamol',
    commonDoses: ['500mg', '650mg', '1000mg'],
    commonFrequencies: ['QID', 'TID', 'BID', 'SOS'],
    commonDurations: ['3 days', '5 days', '7 days'],
    defaultRoute: 'oral',
  },
  {
    name: 'Amoxicillin',
    commonDoses: ['250mg', '500mg', '875mg'],
    commonFrequencies: ['TID', 'BID'],
    commonDurations: ['5 days', '7 days', '10 days'],
    defaultRoute: 'oral',
  },
  {
    name: 'Ibuprofen',
    commonDoses: ['200mg', '400mg', '600mg'],
    commonFrequencies: ['TID', 'BID', 'SOS'],
    commonDurations: ['3 days', '5 days', '7 days'],
    defaultRoute: 'oral',
  },
  {
    name: 'Omeprazole',
    commonDoses: ['20mg', '40mg'],
    commonFrequencies: ['OD', 'BID'],
    commonDurations: ['7 days', '14 days', '30 days'],
    defaultRoute: 'oral',
  },
];

export const testPriceMap: Record<string, number> = {
  'CBC': 25.00,
  'LFT': 35.00,
  'RFT': 30.00,
  'FBS': 15.00,
  'HbA1c': 45.00,
  'TSH': 40.00,
  'ESR': 20.00,
  'CRP': 30.00,
  'URINE': 20.00,
  'LIPID': 50.00,
  'CXR': 60.00,
  'AXR': 55.00,
  'CT-HEAD': 200.00,
  'CT-CHEST': 250.00,
  'CT-ABDOMEN': 280.00,
  'MRI-BRAIN': 400.00,
  'MRI-SPINE': 450.00,
  'USG-ABDOMEN': 80.00,
  'USG-PELVIS': 75.00,
  'ECHO': 120.00,
};
